function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", null, ".share_svg__st0{fill:#b9b8c4}");
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "share_svg__st0",
  d: "M507.5 148.9L368.9 4.9c-4.5-4.7-11.5-6.2-17.5-3.7-6.1 2.5-10 8.3-10 14.8v69.3H336c-114.7 0-208 93.3-208 208v32c0 7.4 5.2 13.6 12.5 15.3 1.2.3 2.3.4 3.5.4 6 0 11.8-3.5 14.6-9.1 30-60 90.3-97.3 157.4-97.3h25.3V304c0 6.5 4 12.4 10 14.8 6 2.5 13 1 17.5-3.7l138.7-144c6-6.2 6-16 0-22.2z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "share_svg__st0",
  d: "M448 512H64c-35.3 0-64-28.7-64-64V149.3c0-35.3 28.7-64 64-64h64c11.8 0 21.3 9.5 21.3 21.3S139.8 128 128 128H64c-11.8 0-21.3 9.6-21.3 21.3V448c0 11.8 9.6 21.3 21.3 21.3h384c11.8 0 21.3-9.6 21.3-21.3V277.3c0-11.8 9.5-21.3 21.3-21.3s21.3 9.5 21.3 21.3V448c.1 35.3-28.6 64-63.9 64z"
});
function SvgShare(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
export default __webpack_public_path__ + "9fb9fbcb35b6add240667d994b7bed99.svg";
export { SvgShare as ReactComponent };